import '../assets/NcHotkey-4yi1Hobg.css';
import { defineComponent, computed } from "vue";
import { N as NcKbd } from "./NcKbd-CfVfr9CW.mjs";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-DU4iP6Vu.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcHotkey",
  props: {
    label: { default: void 0 },
    hotkey: { default: void 0 }
  },
  setup(__props) {
    const props = __props;
    const symbols = computed(() => {
      return props.hotkey?.split(/\s+/).map((s) => s.trim());
    });
    const NO_LABEL_WARNING = "⚠️ NcHotKey must have a label or slot content";
    return { __sfc: true, props, symbols, NO_LABEL_WARNING, NcKbd };
  }
});
const hotkey = "_hotkey_1s86g_20";
const hotkey__label = "_hotkey__label_1s86g_27";
const hotkey__keys = "_hotkey__keys_1s86g_28";
const style0 = {
  "material-design-icon": "_material-design-icon_1s86g_12",
  hotkey,
  hotkey__label,
  hotkey__keys
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("li", { class: _vm.$style.hotkey }, [_c("span", { class: _vm.$style.hotkey__keys, attrs: { "role": "term" } }, [_vm._t("hotkey", function() {
    return _vm._l(_setup.symbols, function(symbol, index) {
      return _c(_setup.NcKbd, { key: index, attrs: { "symbol": symbol } });
    });
  })], 2), _c("span", { class: _vm.$style.hotkey__label, attrs: { "role": "definition" } }, [_vm._t("default", function() {
    return [_vm._v(" " + _vm._s(_vm.label || _setup.NO_LABEL_WARNING) + " ")];
  })], 2)]);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles,
  null
);
const NcHotkey = __component__.exports;
export {
  NcHotkey as N
};
//# sourceMappingURL=NcHotkey-CzuMmIU9.mjs.map
